var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSelectSubject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E0E7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8C10.3438 8 9 9.34375 9 11V21C9 22.6562 10.3438 24 12 24H21H22C22.5531 24 23 23.5531 23 23C23 22.4469 22.5531 22 22 22V20C22.5531 20 23 19.5531 23 19V9C23 8.44687 22.5531 8 22 8H21H12ZM12 20H20V22H12C11.4469 22 11 21.5531 11 21Cnan nan 11.4469 20 12 20ZM13 12.5C13 12.225 13.225 12 13.5 12H19.5C19.775 12 20 12.225 20 12.5Cnan nan 19.775 13 19.5 13H13.5C13.225 13 13 12.775 13 12.5ZM13.5 14H19.5C19.775 14 20 14.225 20 14.5Cnan nan 19.775 15 19.5 15H13.5C13.225 15 13 14.775 13 14.5Cnan nan 13.225 14 13.5 14Z",
    fill: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSelectSubject);
export default __webpack_public_path__ + "static/media/ic_select_subject.9f1b8e8c03542fd8db7f37bb96a800c9.svg";
export { ForwardRef as ReactComponent };